import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUnlockAlt, faUserAlt } from '@fortawesome/free-solid-svg-icons';
//services
import { userService } from '../_services/user.service';
import './SummernoteDependencies';

class SignInModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            signIn: {
                email: '',
                password: '',
                remember: false
            },
            signUp: {
                firstName: '',
                lastName: '',
                username: '',
                email: '',
                password: '',
                confirmPw: '',
            },
            checkPassword: '',
            validEmail: '',
            errorLogIn: '',

            validFirstName: '',
            validLastName: '',
            validUsername: '',
            newEmail: '',
            newPassword: '',
            reEnterPw: '',
            errorSignUp: '',
            successSignUp: '',
        };
        this.loginModal = this.loginModal.bind(this)
        this.handleLogin = this.handleLogin.bind(this);
        this.loginSubmit = this.loginSubmit.bind(this);

        this.clearLogin = this.clearLogin.bind(this);
        this.clearSignUp = this.clearSignUp.bind(this);

        this.handleSignUp = this.handleSignUp.bind(this);
        this.signUpSubmit = this.signUpSubmit.bind(this);
    }

    loginModal() {
        //reset form fields on modal show
        this.setState({
            signIn: {
                email: '',
                password: ''
            },
            signUp: {
                firstName: '',
                lastName: '',
                username: '',
                email: '',
                password: '',
                confirmPw: '',
            },
            checkPassword: '',
            validEmail: '',
            errorLogIn: '',

            validFirstName: '',
            validLastName: '',
            validUsername: '',
            newEmail: '',
            newPassword: '',
            reEnterPw: '',
            errorSignUp: '',
            successSignUp: '',
        });
    }

    clearLogin(e) {
        e.preventDefault();
        this.setState({
            signIn: {
                email: '',
                password: ''
            },
            checkPassword: '',
            validEmail: '',
            errorLogIn: '',
        })
    }

    clearSignUp(e) {
        e.preventDefault();
        this.setState({
            signUp: {
                firstName: '',
                lastName: '',
                username: '',
                email: '',
                password: '',
                confirmPw: '',
            },
            validFirstName: '',
            validLastName: '',
            validUsername: '',
            newEmail: '',
            newPassword: '',
            reEnterPw: '',
            errorSignUp: '',
            successSignUp: '',
        })
    }

    handleLogin(e) {
        e.preventDefault();
        const { signIn } = this.state
        const { value, name } = e.target
        this.setState({
            signIn: {
                ...signIn,
                [name]: value
                // [name]: value.replace(/\s+/g, " ").replace(/^\s+/, "")
            },
        });

        if (name === 'email') {
            this.setState({ validEmail: '' })
        } else if (name === 'password') {
            this.setState({ checkPassword: '' })
        }
    }

    loginSubmit(e) {
        e.preventDefault()
        const { email, password, remember } = this.state.signIn;
        //check email format
        // eslint-disable-next-line
        const validEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const emailCheck = validEmail.test(email);

        if (!email) {
            this.setState({ validEmail: 'email is required' })
        } else if (emailCheck === false) {
            this.setState({ validEmail: 'invalid email address' })
        }

        if (!password) {
            this.setState({ checkPassword: 'password is required' })
        }

        if (email && password && emailCheck) {

            userService.loginUser(email, password, remember)
            .then(result => {
                if (result.success) {
                    // Store user details in state
                    console.log(result);
                    console.log('Login successful!');
                    const close = document.getElementsByClassName('close');
                    close && close[0] && close[0].click();
                    this.setState({ errorLogIn: '' });
                    this.props.handleUser(true);
                } else {
                    console.error(result);
                    this.setState({ errorLogIn: result.error }); // Display the actual error message
                }
            });


            // userService.login(email, password, remember)
            // .then(
            //     user => {
            //         if (user.user && user.user._id) {
            //             const close = document.getElementsByClassName('close')
            //             close && close[0] && close[0].click()
            //             this.setState({ errorLogIn: '' })
            //             this.props.handleUser(true)
            //         } else {
            //             // this.setState({ errorLogIn: user.error ? user.error.toString() :  'Login Failed' })
            //             this.setState({ errorLogIn: 'Login Failed' })
            //         }
            //     },
            // );
        }
    }

    handleSignUp(e) {
        e.preventDefault();
        const { name, value } = e.target;
        const { signUp } = this.state;

        this.setState({
            signUp: {
                ...signUp,
                [name]: value.replace(/\s+/g, " ").replace(/^\s+/, "")
            }
        });

        if (name === 'firstName' || name === 'lastName') {
            this.setState({ validFirstName: '', validLastName: '' })
        } else if (name === 'email') {
            this.setState({ newEmail: '' })
        } else if (name === 'password') {
            this.setState({ newPassword: '' })
        } else if (name === 'confirmPw') {
            this.setState({ reEnterPw: '' })
        } else if(name === 'username'){
            this.setState({username: ''})
        }
    }

    signUpSubmit(e) {
        e.preventDefault();
        const { firstName, lastName, username, email, password, confirmPw } = this.state.signUp;
    
        // Check email format
        const validEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const emailCheck = validEmail.test(email);
    
        // Reset validation messages
        this.setState({
            validFirstName: '',
            validLastName: '',
            validUsername: '',
            newEmail: '',
            newPassword: '',
            reEnterPw: '',
            successSignUp: '',
            errorSignUp: ''
        });
    
        // Perform validation
        if (!firstName) {
            this.setState({ validFirstName: 'First Name is required' });
        }
    
        if (!lastName) {
            this.setState({ validLastName: 'Last Name is required' });
        }
    
        if (!username) {
            this.setState({ validUsername: 'Username is required' });
        }
    
        if (!email) {
            this.setState({ newEmail: 'Email is required' });
        } else if (!emailCheck) {
            this.setState({ newEmail: 'Invalid email address' });
        }
    
        if (!password) {
            this.setState({ newPassword: 'Password is required' });
        }
    
        if (!confirmPw) {
            this.setState({ reEnterPw: 'Please retype your password' });
        } else if (password !== confirmPw) {
            this.setState({ reEnterPw: "Passwords didn't match" });
        }
    
        // If all fields are valid, proceed with registration
        if (firstName && lastName && username && email && password && confirmPw && emailCheck && password === confirmPw) {
            const userData = {
                username: username,
                first_name: firstName,
                last_name: lastName,
                email: email,
                password: password,
                role: 'customer' // Assign the 'customer' role to the user
            };
    
            // Call the API to register the user
            userService.registerUser(userData)
                .then(response => {
                    if (response && response.message === "User registered successfully") {
                        // Reset the form and show success message
                        this.setState({
                            successSignUp: 'Account created successfully!',
                            signUp: {
                                firstName: '',
                                lastName: '',
                                username: '',
                                email: '',
                                password: '',
                                confirmPw: '',
                            }
                        });
    
                        // Programmatically switch to sign-in tab after successful registration
                        setTimeout(() => {
                            const signInTabButton = document.getElementById('signin-tab');
                            if (signInTabButton) {
                                signInTabButton.click();
                            }
                        }, 5500); // 2000 milliseconds = 2 seconds
                    } else {
                        // Show error message if registration failed
                        this.setState({ errorSignUp: (response && response.message) || 'Signup Failed' });

                    }
                })
                .catch(error => {
                    // Handle registration error
                    console.error('Failed to signup:', error.message);
                    this.setState({ errorSignUp: error.message || 'Signup Failed' });
                });

                // userService.create(signUpBody).then(signIn => {
                //     if(signIn.success){
                //         this.setState({
                //             successSignUp: 'Account created successfully!',
                //             signUp: {
                //                 firstName: '',
                //                 lastName: '',
                //                 email: '',
                //                 password: '',
                //                 confirmPw: '',
                //             },
                //         },()=>{
                //             setTimeout(()=>{ 
                //                 const close = document.getElementById('signin-tab')
                //                 close && close.click()
                //             }, 2000);
                //         })
                //     }else{
                //         this.setState({ errorSignUp: signIn.error || 'Signup Failed' })
                //     }
                // })
            
        }
    }

    render() {
        const { validUsername, signIn, signUp, validEmail, checkPassword, errorLogIn, validFirstName, validLastName, newEmail, newPassword, reEnterPw, errorSignUp, successSignUp } = this.state;
        
        return (
            <div className="modal fade account-login" id="AccountLogin" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" style={{ display: "none" }} aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header pb-0">
                            <ul className="nav justify-content-start" id="Accounts-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <a className="nav-link active" id="signin-tab" data-toggle="tab" href="#signin" role="tab" aria-controls="signin" aria-selected="true" onClick={(e) => this.clearSignUp(e)}><FontAwesomeIcon icon={faUnlockAlt} aria-hidden="true" /> Sign In</a>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <a className="nav-link" id="signup-tab" data-toggle="tab" href="#signup" role="tab" aria-controls="signup" aria-selected="false" onClick={(e) => this.clearLogin(e)}><FontAwesomeIcon icon={faUserAlt} aria-hidden="true" /> Sign Up</a>
                                </li>
                            </ul>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        {/* <!-- Tab panes --> */}
                        <div className="tab-content">
                            <div className="tab-pane active" id="signin" role="tabpanel" aria-labelledby="signin-tab">
                                <form onSubmit={this.loginSubmit}>
                                    <>
                                        <div className="modal-body pb-0">
                                            {/* <form onSubmit={this.loginSubmit}> */}
                                            <div className="form-row">
                                                {errorLogIn && <small className="form-text text-danger" style={{marginBottom:'0.25rem'}}>{errorLogIn}</small >}
                                                <div className="form-group col-12">
                                                    <label htmlFor="">Email Address</label>
                                                    {validEmail ?
                                                        <>
                                                            <input type="text" name="email" value={signIn.email} className="form-control is-invalid btn-lg" onChange={(e) => this.handleLogin(e)} />
                                                            {validEmail && <small className="form-text text-danger">{validEmail}</small >}
                                                        </>
                                                        :
                                                        <input type="text" name="email" value={signIn.email} className="form-control btn-lg" onChange={(e) => this.handleLogin(e)} />
                                                    }
                                                </div>
                                                <div className="form-group col-12">
                                                    <label htmlFor="">Password</label>
                                                    {checkPassword ?
                                                        <>
                                                            <input type="password" name="password" value={signIn.password} className="form-control is-invalid btn-lg" onChange={(e) => this.handleLogin(e)} />
                                                            {checkPassword && <small className="form-text text-danger">{checkPassword}</small >}
                                                        </>
                                                        :
                                                        <input type="password" name="password" value={signIn.password} className="form-control btn-lg" onChange={(e) => this.handleLogin(e)} />
                                                    }
                                                </div>
                                                <div className="form-group col-6">
                                                    <div className="form-check">
                                                        <input type="checkbox" className="form-check-input" value={signIn.remember} onChange={(e) => this.setState({
                                                            ...this.state,
                                                            signIn: {
                                                                ...this.state.signIn,
                                                                remember: !!e.target.value
                                                            }
                                                            })} />
                                                        <label htmlFor="" className="form-check-label">Remember me</label>
                                                    </div>
                                                </div>
                                                <div className="form-group col-6 text-right">
                                                    <a href="/reset-password" className="text-primary"><small>Forgot password?</small></a>
                                                </div>
                                            </div>
                                            {/* </form> */}
                                        </div>
                                        <div className="modal-footer">
                                            <button className="btn btn-primary btn-block btn-lg">Sign In</button>
                                        </div>
                                    </>
                                </form>
                            </div>
                            <div className="tab-pane" id="signup" role="tabpanel" aria-labelledby="signup-tab">
                                <form onSubmit={this.signUpSubmit}>
                                    <>
                                        <div className="modal-body pb-0">
                                            {/* <form action=""> */}
                                            <div className="form-row">
                                                {errorSignUp && <small className="form-text text-danger" style={{marginBottom:'0.25rem'}}>{errorSignUp}</small >}
                                                {successSignUp && <small className="form-text text-success" style={{marginBottom:'0.25rem'}}>{successSignUp}</small >}
                                                <div className="form-group col-12">
                                                    <label htmlFor="">First Name</label>
                                                    {validFirstName ?
                                                        <>
                                                            <input type="text" name="firstName" value={signUp.firstName} className="form-control is-invalid btn-lg" onChange={(e) => this.handleSignUp(e)} />
                                                            {validFirstName && <small className="form-text text-danger">{validFirstName}</small >}
                                                        </>
                                                        :
                                                        <input type="text" name="firstName" value={signUp.firstName} className="form-control btn-lg" onChange={(e) => this.handleSignUp(e)} />
                                                    }
                                                </div>
                                                <div className="form-group col-12">
                                                    <label htmlFor="">Last Name</label>
                                                    {validLastName ?
                                                        <>
                                                            <input type="text" name="lastName" value={signUp.lastName} className="form-control is-invalid btn-lg" onChange={(e) => this.handleSignUp(e)} />
                                                            {validLastName && <small className="form-text text-danger">{validLastName}</small >}
                                                        </>
                                                        :
                                                        <input type="text" name="lastName" value={signUp.lastName} className="form-control btn-lg" onChange={(e) => this.handleSignUp(e)} />
                                                    }
                                                </div>
                                                <div className="form-group col-12">
                                                    <label htmlFor="">UserName</label>
                                                    {validUsername ?
                                                        <>
                                                            <input type="text" name="username" value={signUp.username} className="form-control is-invalid btn-lg" onChange={(e) => this.handleSignUp(e)} />
                                                            {validUsername && <small className="form-text text-danger">{validLastName}</small >}
                                                        </>
                                                        :
                                                        <input type="text" name="username" value={signUp.username} className="form-control btn-lg" onChange={(e) => this.handleSignUp(e)} />
                                                    }
                                                </div>
                                                <div className="form-group col-12">
                                                    <label htmlFor="">Email Address</label>
                                                    {newEmail ?
                                                        <>
                                                            <input type="text" name="email" value={signUp.email} className="form-control is-invalid btn-lg" onChange={(e) => this.handleSignUp(e)} />
                                                            {newEmail && <small className="form-text text-danger">{newEmail}</small >}
                                                        </>
                                                        :
                                                        <input type="text" name="email" value={signUp.email} className="form-control btn-lg" onChange={(e) => this.handleSignUp(e)} />
                                                    }
                                                </div>
                                                <div className="form-group col-12">
                                                    <label htmlFor="">Password</label>
                                                    {newPassword ?
                                                        <>
                                                            <input type="password" name="password" value={signUp.password} className="form-control is-invalid btn-lg" onChange={(e) => this.handleSignUp(e)} />
                                                            {newPassword && <small className="form-text text-danger">{newPassword}</small >}
                                                        </>
                                                        :
                                                        <input type="password" name="password" value={signUp.password} className="form-control btn-lg" onChange={(e) => this.handleSignUp(e)} />
                                                    }
                                                </div>
                                                <div className="form-group col-12">
                                                    <label htmlFor="">Confirm Password</label>
                                                    {reEnterPw ?
                                                        <>
                                                            <input type="password" name="confirmPw" value={signUp.confirmPw} className="form-control is-invalid btn-lg" onChange={(e) => this.handleSignUp(e)} />
                                                            {reEnterPw && <small className="form-text text-danger">{reEnterPw}</small >}
                                                        </>
                                                        :
                                                        <input type="password" name="confirmPw" value={signUp.confirmPw} className="form-control btn-lg" onChange={(e) => this.handleSignUp(e)} />
                                                    }
                                                </div>
                                            </div>
                                            {/* </form> */}
                                        </div>
                                        <div className="modal-footer">
                                            <button className="btn btn-primary btn-block btn-lg">Sign Up</button>
                                        </div>
                                    </>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export { SignInModal }